import { render } from "./excursionInfo.vue?vue&type=template&id=e175f594&scoped=true"
import script from "./excursionInfo.vue?vue&type=script&lang=js"
export * from "./excursionInfo.vue?vue&type=script&lang=js"

import "./excursionInfo.vue?vue&type=style&index=0&id=e175f594&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e175f594"]])

export default __exports__